/* Step-by-step Angular component for displaying multiple tables for a teacher */

// 1. Create a new module and component:
// ng generate module teacher-index
// ng generate component teacher-index/teacher-index-view

// 2. teacher-index-view.component.ts
import { Component, Input, OnInit } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { HttpService } from 'src/app/shared/service/http.service';
@Component({
  selector: 'app-teacher-index-view',
  templateUrl: './teacher-index-view.component.html',
  styleUrls: ['./teacher-index-view.component.scss'],
})
export class TeacherIndexViewComponent implements OnInit {
  @Input() selectedRow: any;

  constructor(private httpService: HttpService) {}

  table: {
    source: LocalDataSource;
    settings: any;
    title?: string;
    indexId?: string;
  }[] = [];
  showOnly = 10; // Number of tables to show, can be paginated later

  ngOnInit(): void {
    this.httpService
      .getIndexDataByTeacher(this.selectedRow.name)
      .then((res: any) => {
        console.log('API Response:', res);
        if (res && res.length > 0) {
          // Group by indexId instead of title fields
          const grouped = this.groupByIndexId(res);
          console.log('Grouped data:', grouped);

          // Create table array with indexId for sorting
          let tableArray = Object.entries(grouped).map(([key, items]) => {
            // Extract the numeric part from the key (e.g., "Index 11" -> "11")
            const indexId = key.replace('Index ', '');

            return {
              title: key,
              indexId: indexId,
              source: new LocalDataSource(items),
              settings: this.generateSettings(items[0]),
            };
          });

          // Sort tables by indexId numerically
          tableArray.sort((a, b) => {
            return parseInt(a.indexId) - parseInt(b.indexId);
          });

          this.table = tableArray;
          console.log('Final sorted table data:', this.table);
        } else {
          console.log('No data received from API');
        }
      })
      .catch((err) => {
        console.error('getIndexDataByTeacher error:', err);
      });
  }

  // New method to group by indexId which is more reliable
  groupByIndexId(data: any[]): Record<string, any[]> {
    const groups: Record<string, any[]> = {};

    data.forEach((itemArray) => {
      // Find the item with indexId
      const indexItem = itemArray.find((field) => field.indexId);
      if (!indexItem) return;

      const indexId = indexItem.indexId;
      const key = `Index ${indexId}`;

      if (!groups[key]) groups[key] = [];
      groups[key].push(this.flattenForTable(itemArray));
    });

    return groups;
  }

  // Keep the original method for backward compatibility
  groupByIndexType(data: any[][]): any[][] {
    const groups: Record<string, any[]> = {};
    data.forEach((itemArray) => {
      const key = this.generateTypeKey(itemArray);
      if (!groups[key]) groups[key] = [];
      groups[key].push(this.flattenForTable(itemArray));
    });
    return Object.values(groups);
  }

  generateTypeKey(entry: any[]): string {
    // Create a unique key based on the titles present in the entry (excluding file, created, etc.)
    return entry
      .filter((field) => field.title && field.type !== 'file')
      .map((field) => field.title)
      .sort()
      .join('|');
  }

  flattenForTable(entry: any[]): any {
    const obj: any = {};
    entry.forEach((field) => {
      if (field.title && field.value !== undefined) {
        obj[field.title] = Array.isArray(field.value)
          ? field.value
              .map((f) => `<a href="${f.url}" target="_blank">${f.name}</a>`)
              .join(', ')
          : field.value;
      }
    });

    // Add a special field for created date if available
    const createdField = entry.find((field) => field.created);
    if (createdField) {
      obj['Created Date'] = createdField.created;
    }

    return obj;
  }

  generateSettings(flattenedItem: any): any {
    if (!flattenedItem) {
      return {
        actions: false,
        hideSubHeader: true,
        columns: {},
      };
    }

    const columns: any = {};
    Object.keys(flattenedItem).forEach((key) => {
      columns[key] = { title: key, type: 'html' };
    });

    return {
      actions: false,
      hideSubHeader: true,
      columns,
    };
  }
}
